define('postLogin/handleUnAuthorized',['lodash', 'jquery', 'plugins/router', 'atn/atn', './logout'], function(_, $, router, atn, logout) {
    'use strict';
    /**
     * This  takes the ajax error that is thrown from any of the promises
     * if error status is 401 then invoke handleUnAuthorized function.
     */
    $(document).ajaxError(function(e, xhr) {
        var promise;
        if (xhr.status === 403) {
            if (!atn.isLoggedOut()) {
                promise = logout.thisServiceLogout();
                promise.fail(function(xhr){
                    if(xhr.status === 403){
                        atn.isLoggedOut(true);
                        _.defer(router.navigate, '#site/logout');
                    }
                });
            }
        }
    });
});
